import { getMerchantToken } from "./merchantAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_MERCHANT_API_BASE_URL ||
  "http://secondbite-manage.localhost/merchant-api/v1"
).replace(/\/+$/, "");

const request = async (path, options = {}) => {
  let response;

  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getMerchantToken()}`,
        ...(options.headers || {}),
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors
      ? Object.values(payload.errors).flat()[0]
      : null;
    throw new Error(validationMessage || payload?.message || "Unable to update the pickup queue.");
  }

  return payload.data;
};

export const getPickupQueue = (outletId) =>
  request(`/pickup-queue/${outletId}`);

export const markPickupOrderCollected = (outletId, orderId) =>
  request(`/pickup-queue/${outletId}/orders/${orderId}/collect`, {
    method: "PATCH",
  });
